<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Breadcrumb from '@/components/navigation/Breadcrumb.vue';

defineOptions({ name: 'AppContent' });

defineProps({
    collapsed: {
        type: Boolean,
        required: true
    },
    isMobile: {
        type: Boolean,
        required: true
    }
});

const route = useRoute();
/** 頁內已有自己的頂欄（返回／標題）時，隱藏全域麵包屑＋大標題，避免雙層佔高 */
const hidePageChrome = computed(() => Boolean(route.meta?.hidePageChrome));
</script>

<template>
    <!-- Views 區域 -->
    <div class="pt-16 min-h-screen w-full admin-content-bg">
        <!-- 麵包屑和標題 -->
        <div
            v-if="!hidePageChrome"
            class="admin-page-chrome no-print fixed top-16 z-30 pt-3 pb-3 border-b border-slate-200/80 bg-white/90 backdrop-blur-md shadow-sm shadow-slate-900/5"
            :class="isMobile ? 'px-3' : 'px-6 lg:px-8'"
            :style="{
                width: isMobile
                    ? '100%'
                    : `calc(100% - ${collapsed ? '80px' : '200px'})`,
                left: isMobile ? '0' : collapsed ? '80px' : '200px',
                transition: 'all 0.3s'
            }"
        >
            <Breadcrumb />
            <h2 class="text-lg sm:text-xl font-semibold text-[#272b36] tracking-tight mt-1">
                {{ $route.meta.title }}
            </h2>
        </div>

        <!-- 內容區域 -->
        <a-layout-content
            class="pb-16 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]"
            :class="hidePageChrome ? 'mt-0' : 'mt-[5.25rem]'"
        >
            <div
                class="admin-page-shell mx-auto w-full px-3 sm:px-6 lg:px-10"
                :class="hidePageChrome ? 'py-4 max-w-none' : 'py-6 max-w-[1680px]'"
            >
                <router-view :key="$route.fullPath" />
            </div>
        </a-layout-content>
    </div>
</template>
